/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   getClosestEntity
 */

import getDistanceFromCenter, { type MaybeCoords } from './getDistanceFromCenter'

const getClosestEntity = <T extends MaybeCoords>(center: MaybeCoords, entities?: readonly T[]) => {
  if (Array.isArray(entities) && entities.length) {
    let closestEntity: T = entities[0]
    let bestDistance: number | undefined
    entities.forEach((entity) => {
      const distance = getDistanceFromCenter(center, entity)
      if (bestDistance === undefined || (distance !== undefined && distance < bestDistance)) {
        closestEntity = entity
        bestDistance = distance
      }
    })
    return closestEntity
  }
  return undefined
}

export default getClosestEntity
